/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./shareButtonDialogue.vue?vue&type=template&id=5066607e&scoped=true"
import script from "./shareButtonDialogue.vue?vue&type=script&lang=js"
export * from "./shareButtonDialogue.vue?vue&type=script&lang=js"
import style0 from "./shareButtonDialogue.vue?vue&type=style&index=0&id=5066607e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5066607e",
  null
  
)

export default component.exports